let isIntercomLoaded = false;

function loadIntercom(callback, displayByDefault = false) {

  if (isIntercomLoaded) {
    if (callback) {
      callback();
    }
    return;
  }
  isIntercomLoaded = true;

  (function (c) {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/zrfc296i';
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }

      if (c) {
        c();
      }
    }
  })(() => {
    console.debug(`Intercom loaded (displayByDefault=${displayByDefault})`);

    window.Intercom('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'zrfc296i',
      hide_default_launcher: displayByDefault === false,
    });

    if (callback) {
      callback();
    }

    _setupIntercomButtons();
  });
}

function _setupIntercomButtons() {
  const intercomOpenChatButtons = document.querySelectorAll('.intercom-open-chat-button');
  intercomOpenChatButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      window.Intercom('show');
      console.debug('Opened Intercom chat');
    });
  });
}

export default loadIntercom;